import Router from 'vue-router'
import goTo from '../node_modules/vuetify/es5/services/goto'
// Vuex
import store from './store.js';

// const HelloWorld = () => import('./components/HelloWorld.vue')
// const Test = () => import('./components/Test.vue')
// const temp = () => import('./components/TestReserve.vue')
const Home = () => import('./components/top/HelloWorld.vue')
const Page403 = () => import('./components/Page403.vue')
const Page404 = () => import('./components/Page404.vue')
const reportDownloads = () => import('./components/reportDownloads/Index.vue')

const My = () => import('./components/my/Index.vue')
const Setting = () => import('./components/printSetting/Index.vue')
const delivery = () => import('./components/delivery/Index.vue')
const deliveryPrint = () => import('./components/delivery/DeliveryPrint.vue')
const batchDeliveryPrint = () => import('./components/delivery/BatchDeliveryPrint.vue')
const deliveryDetail = () => import('./components/delivery/Detail.vue')
const deliveryEdit = () => import('./components/delivery/DeliveryEdit.vue')
const receipt = () => import('./components/receipt/Index.vue')
const receiptDetail = () => import('./components/receipt/Detail.vue')
const materialAnalyze = () => import('./components/materialAnalyze/Index.vue')
const materialAnalyzeDetail = () => import('./components/materialAnalyze/Detail.vue')
const question = () => import('./components/question/Index.vue')
const questionDetail = () => import('./components/question/Detail.vue')
const economies = () => import('./components/economies/Index.vue')
const economiesDetail = () => import('./components/economies/Detail.vue')
const stockOuts = () => import('./components/stockOuts/Index.vue')
const stockOutsDetail = () => import('./components/stockOuts/Detail.vue')
const supplierMaterials = () => import('./components/supplierMaterials/Index.vue')
const notification = () => import('./components/notification/Index.vue')
const cloudPrinterSetting = ()=> import('./components/cloudPrintSetting/Index.vue')
const cloudPrintTemplates = () => import('./components/cloudPrintTemplates/Index.vue')
const purchases = () => import('./components/purchases/Index.vue')
const purchasesDetail = ()=> import('./components/purchases/Detail.vue')

var router = new Router({
    routes: [
        { path: '/', component: Home },//首页
        { path: '/home', component: Home },//首页
        
        // add routers here
        { path: '/my', component: My},// 我的
        { path: '/print-templates', component: Setting},// 打印设置
        { path: '/delivery', component: delivery },//发货一览
        { path: "/purchases", component: purchases },//采购一览
        { path: "/purchases/detail/:id", component: purchasesDetail },//采购一览明细
        { path: "/purchases/edit/:id", component: deliveryEdit },//采购 发货 编辑
        { path: "/purchases/new" ,component: purchasesDetail },//新建采购单 
        { path: '/print/delivery-print/:id', component: deliveryPrint },// 打印
        { path: '/print/batch-delivery-print', component: batchDeliveryPrint },// 批量打印
        { path: '/delivery/:id', component: deliveryDetail},//发货一览明细
        { path: '/delivery/edit/:id', component: deliveryEdit},//发货 编辑
        // { path: '/delivery/:id/:mode', component: deliveryDetail},//发货编辑
        { path: '/receipt', component: receipt},//账单一览
        { path: '/receipt/:id', component: receiptDetail},//账单一览明细
        { path: '/material-analyze', component: materialAnalyze},//供应商商品统计
        { path: '/material-analyze/:id', component: materialAnalyzeDetail},//供应商商品统计明细
        { path: '/question', component: question},//报价
        { path: '/question/new', component: questionDetail},//报价新建
        { path: '/question/:id', component: questionDetail},//报价明细
        { path: '/question/:id/:mode', component: questionDetail},//报价编辑
        { path: '/economies', component: economies},//定价
        { path: '/economies/:id', component: economiesDetail},//定价明细
        { path: '/stock-outs', component: stockOuts},//退货
        { path: '/stock-outs/:id', component: stockOutsDetail},//退货明细
        
        { path: '/supplier-materials', component: supplierMaterials},// 商品一览
        { path: "/notification", component: notification }, // 通知

        { path: '/cloud-printer-setting', component: cloudPrinterSetting},// 云打印机设置
        { path: "/cloud-print-templates", component: cloudPrintTemplates }, // 云打印机模板设置

        { path: '/report-downloads', component: reportDownloads },//报表下载
        { path: '/page404', component: Page404 },//Page404
        { path: '/page403', component: Page403 },//Page404
        { path: '*', component: Page404 }
    ],
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        return goTo(scrollTo);
    },
})

router.beforeEach((to, from, next) => {
    store.commit("searchDistrict", false);// 导航切换时默认关闭侧边栏的门店分组搜索控件
    next();
})

export default router